var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube-icon_svg__Youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "youtube-icon_svg__back",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.660889 12C0.660889 5.37258 6.03417 0 12.6625 0C19.2907 0 24.664 5.37258 24.664 12C24.664 18.6274 19.2907 24 12.6625 24C6.03417 24 0.660889 18.6274 0.660889 12Z",
    fill: "#CE1312"
  }), /*#__PURE__*/React.createElement("path", {
    id: "youtube-icon_svg__Youtube_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9352 9.58454C18.9352 9.58454 18.81 8.68322 18.4264 8.28632C17.9395 7.76515 17.3938 7.76269 17.1438 7.73244C15.3524 7.60001 12.6652 7.60001 12.6652 7.60001H12.6596C12.6596 7.60001 9.97248 7.60001 8.18105 7.73244C7.93061 7.76269 7.38534 7.76515 6.89808 8.28632C6.51443 8.68322 6.38961 9.58454 6.38961 9.58454C6.38961 9.58454 6.2616 10.6432 6.2616 11.7015V12.694C6.2616 13.7527 6.38961 14.811 6.38961 14.811C6.38961 14.811 6.51443 15.7123 6.89808 16.1092C7.38534 16.6304 8.02503 16.614 8.30986 16.6684C9.334 16.7689 12.6624 16.8 12.6624 16.8C12.6624 16.8 15.3524 16.7959 17.1438 16.6635C17.3938 16.6328 17.9395 16.6304 18.4264 16.1092C18.81 15.7123 18.9352 14.811 18.9352 14.811C18.9352 14.811 19.0633 13.7527 19.0633 12.694V11.7015C19.0633 10.6432 18.9352 9.58454 18.9352 9.58454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "youtube-icon_svg__Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3407 13.8966L11.3403 10.2214L14.7991 12.0653L11.3407 13.8966Z",
    fill: "#CE1312"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.79ecdb9b8a7fdc289eca3ea317a8ed08.svg";
export { ForwardRef as ReactComponent };